<template>
  <div class="out">
    <choice />
    <div class="stickybar">
      <a :style="partI===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(1)">公司介绍</a>
      <a :style="partII===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(2)">联系我们</a>
      <a :style="partIII===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(3)">公司地址</a>
    <!-- <a @click="jump(4)" :style="partIV===true ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}">优秀实践</a> -->
    </div>
    <div
      ref="parti"
      class="review"
      style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <div id="partone" class="top-text3">
          <h3>公司介绍</h3>
          <p>睿泽信息技术有限公司是2018年于苏州成立的新兴互联网公司，是专业从事产业互联网服务与信息化解决方案的高新技术软件企业，公司拥有多年的项目经验和专业的研发咨询团队，短短几年时间，已经提供了多项优质的解决方案服务。
          <br>自成立以来，睿泽一直致力于用创新和技术推动商业和社会的进步, 并且秉承着持续创新、专业奋斗的核心价值观，一切源于为客户创造价值。</p>
          <br>
          <myCarousel :imgarray="imgarray" />
        </div>
      </div>
    </div>
    <div id="parttwo" ref="partii" class="review" style="background-color:#F7F7F7; margin-left: 0; margin-right:0">
      <div class="title">
        <div class="top-text">
          <div id="success-box" class="contact-box" name="success-box">
            <div class="contact-content">
              <h3 class="section-title contact-content-title">联系我们</h3>
              <div class="contact-content-box">
                <div class="contact-content-item">
                  <p class="contact-content-item-title">售前热线</p>
                  <hr>
                  <p class="contact-content-item-phone">186-2966-7711</p>
                  <p class="contact-content-item-slogan">
                    为您提供售前购买咨询、解决方案推荐等1V1服务，助您上云无忧！（周一至周五：08:30-18:30；周六周日及法定节日：09:00-17:00）</p>
                </div>
                <div class="contact-content-item">
                  <p class="contact-content-item-title">售后咨询</p>
                  <hr>
                  <p class="contact-content-item-phone">186-2966-7711</p>
                  <p class="contact-content-item-slogan">立即与睿泽专家联系，咨询产品和数字化解决方案的售后服务</p>
                  <!-- <a href="" class="advisory-pc-item-before"><div class="contact-content-item-btn">立即咨询</div></a> -->
                </div>
                <div class="contact-content-item">
                  <p class="contact-content-item-title">让我们与您联系</p>
                  <hr>
                  <p class="contact-content-item-phone">budsoft@budsoft.com</p>
                  <p class="contact-content-item-slogan">任何问题均可以向此邮箱发送邮件咨询</p>
                  <!-- <a href=""><div class="contact-content-item-btn">申请体验</div></a> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="partthree" ref="partiii" class="review" style="margin-left: 0; margin-right:0;">
      <div class="top-text2">
        <h2>公司地址</h2>
        <baidu-map :center="center" :zoom="zoom" :scroll-wheel-zoom="true" class="map">
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
          <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT" />
          <bm-geolocation :show-address-bar="true" :auto-location="true" anchor="BMAP_ANCHOR_BOTTOM_RIGHT"/>
          <!-- <bm-view :style="{width:'80%',height: '100%',float: 'left',marginTop:'0px'}" /> -->
          <bm-marker :position="{lng: 120.739984, lat: 31.258718 }" :dragging="false" animation="BMAP_ANIMATION_BOUNCE"/>
          <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"/>
        <!-- <bm-local-search :keyword="keyword" :auto-viewport="false" :location="location2" style="height: 360px; float: left; width: 40%; overflow-y: scroll;margin: 40px 0 0" /> -->
        <!-- <div class="searchBar">
          <label id= "label1">关键词：<input v-model="keyword"></label>
          <label id= "label2">地区：<input v-model="location"></label>
        </div> -->
        <!-- <bm-local-search :keyword="keyword" :auto-viewport="true" :location="location" style="height: 600px;float:left; text-align:left;width: 1200px;"></bm-local-search> -->
        </baidu-map>
      </div>
    </div>
  </div>
</template>
<script>
import myCarousel from '@/components/carousel'
import choice from '@/components/choice'
export default {
  components: { myCarousel, choice },
  data() {
    return {
      header: '关于我们',
      leader: '在这里，获得事业的发展和成长',
      center: { lng: 120.739984, lat: 31.258718 },
      zoom: 18,
      location: '苏州',
      keyword: '苏州睿泽信息技术有限公司',
      partI: false,
      partII: false,
      partIII: false,
      imgarray: [
        { title: 'img1', url: 'https://picsum.photos/1024/480/?image=52', text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo deleniti dicta fuga minima qui excepturi consequatur pariatur nisi voluptatem consectetur enim, voluptate eos, obcaecati, iusto repellendus tenetur doloremque sequi libero.' },
        { title: 'img2', url: 'https://picsum.photos/1024/480/?image=54', text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo deleniti dicta fuga minima qui excepturi consequatur pariatur nisi voluptatem consectetur enim, voluptate eos, obcaecati, iusto repellendus tenetur doloremque sequi libero.' },
        { title: 'img3', url: 'https://picsum.photos/1024/480/?image=58', text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo deleniti dicta fuga minima qui excepturi consequatur pariatur nisi voluptatem consectetur enim, voluptate eos, obcaecati, iusto repellendus tenetur doloremque sequi libero.' },
        { title: 'img4', url: 'https://picsum.photos/1024/480/?image=55', text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo deleniti dicta fuga minima qui excepturi consequatur pariatur nisi voluptatem consectetur enim, voluptate eos, obcaecati, iusto repellendus tenetur doloremque sequi libero.' }
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollLisenter)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollLisenter)
  },
  methods: {
    jump: function(x) {
      if (x === 1) {
        x = '#partone'
      }
      if (x === 2) {
        x = '#parttwo'
      }
      if (x === 3) {
        x = '#partthree'
      }
      if (x === 4) {
        x = '#partfour'
      }
      document.querySelector(x).scrollIntoView(true)
    },
    scrollLisenter: function() {
      var length = document.documentElement.scrollTop + 37
      if (length >= 0 && length < this.$refs.partii.offsetTop) {
        this.partI = true
      } else this.partI = false
      if (length > this.$refs.partii.offsetTop && length < this.$refs.partiii.offsetTop) {
        this.partII = true
      } else this.partII = false
      if (length > this.$refs.partiii.offsetTop) {
        this.partIII = true
      } else this.partIII = false
    }
  }
}
</script>

<style scoped>
.page-title {
  background-image: url("../assets/banner_jp.jpeg");
  background-size: 100% 400px;
  height: 100%;
  text-align: left;
  padding-top: 60px;
  padding-bottom: 2px;
  /* max-width: 1200px; */
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.page-title::before {
    position: absolute;
    content: '';
    background: rgba(1,12,41,.85);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
}
.page-title .btn {
  border-radius: 0;
}
.map {
  width: 1200px;
  height: 600px;
  margin: auto;
}
.stickybar {
  position: sticky;
  top: 0;
  display: flex;
  background-color: white;
  z-index: 99;
  padding: 0% 7% 0% 13%;
}
.stickybar a {
  padding: 2% 4%;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
.top-text {
  padding: 72px 0;
  margin: 0 auto;
  height: auto;
}
.title {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
}
.contact-content {
    width: 1200px;
    /* height: 436px; */
    margin: auto;
    /* display: none; */
}
.contact-content-box {
    display: flex;
    flex-direction: row;
}
.contact-content-item {
    width: 400px;
    height: 243px;
    padding-top: 40px;
    padding-right: 65px;
    text-align: justify;
}
.section-title {
    font-size: 32px;
    color: #061828;
    line-height: 40px;
    padding: 0px 0 20px;
}
hr {
    width: 229px;
    height: 1px;
    background: linear-gradient(90deg, #0086F1 0%, rgba(0, 134, 241, 0) 100%);
    margin: 14px 0 20px;
}
.contact-content-item-title {
    font-size: 24px;
    font-weight: bold;
    color: #061828;
    line-height: 24px;
}
.contact-content-item-slogan {
    font-size: 14px;
    color: #282828;
    opacity: 0.75;
    line-height: 24px;
    margin-top: 15px;
}
.contact-content-item-btn {
    width: 100px;
    height: 40px;
    font-size: 14px;
    color: #0086F1;
    line-height: 40px;
    border: 1px solid #0085f1;
    opacity: 0.75;
    text-align: center;
    margin-top: 20px;
}
.contact-content-item-phone {
  font-weight: bolder;
  font-size: 30px;
  line-height: 24px;
}
.top-text2 h2{
  padding-bottom:2%;
}
.top-text2 {
  padding: 6.1% 0 5% 0;
  margin: 0 auto;
  height: auto;
}
.top-text3 {
  padding: 72px 0;
  margin: 0 auto;
  height: auto;
  
}
.top-text3 p {
  padding-top: 20px;
  line-height: 34px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue